import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip, IconButton } from '@mui/material';
import {
  Person as PersonIcon,
  Description as DocumentIcon,
  Assignment as AssignmentIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';

const getStatusColor = (status) => {
  if (status === true) return 'success.main';
  if (status === false) return 'error.main';
  return 'grey.400';
};

const getStatusIcon = (type) => {
  switch (type) {
    case 'debtor':
      return PersonIcon;
    case 'emission':
      return DocumentIcon;
    case 'rug':
      return AssignmentIcon;
    case 'payment':
      return AssignmentIcon;
    default:
      return WarningIcon;
  }
};

const getTooltipText = (type, status) => {
  let statusText;
  if (status === true) {
    statusText = 'OK';
  } else if (status === false) {
    statusText = 'No cumple';
  } else {
    statusText = 'Revisar manualmente';
  }

  switch (type) {
    case 'debtor':
      return `Deudor autorizado: ${statusText}`;
    case 'emission':
      return `Emisión menor a 30 días: ${statusText}`;
    case 'rug':
      return `Inscrita en el RUG: ${statusText}`;
    case 'payment':
      return `Sin complemento de pago: ${statusText}`;
    default:
      return `Estado: ${statusText}`;
  }
};

const ComplianceStatusCell = ({ invoice }) => {
  const { complianceStatus } = invoice;

  if (!complianceStatus) {
    return (
      <Box display="flex" gap={0.5}>
        <Tooltip title="Estado de cumplimiento no disponible">
          <IconButton size="small" disabled>
            <WarningIcon sx={{ color: 'grey.400' }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  const statusItems = [
    {
      type: 'debtor',
      status: complianceStatus.debtorApproved,
      tooltip: getTooltipText('debtor', complianceStatus.debtorApproved),
    },
    {
      type: 'emission',
      status: complianceStatus.withinAvailableDays,
      tooltip: getTooltipText('emission', complianceStatus.withinAvailableDays),
    },
    {
      type: 'rug',
      status: complianceStatus.rugInscribed,
      tooltip: getTooltipText('rug', complianceStatus.rugInscribed),
    },
    {
      type: 'payment',
      status: !complianceStatus.hasPaymentComplement,
      tooltip: getTooltipText('payment', !complianceStatus.hasPaymentComplement),
    },
  ];

  return (
    <Box display="flex" gap={0.5}>
      {statusItems.map((item) => {
        const IconComponent = getStatusIcon(item.type);
        const color = getStatusColor(item.status);

        return (
          <Tooltip key={item.type} title={item.tooltip} arrow>
            <IconButton size="small" sx={{ p: 0.5 }}>
              <IconComponent
                sx={{
                  color,
                  fontSize: '1rem',
                }}
              />
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
};

ComplianceStatusCell.propTypes = {
  invoice: PropTypes.shape({
    complianceStatus: PropTypes.shape({
      debtorApproved: PropTypes.bool,
      withinAvailableDays: PropTypes.bool,
      hasPaymentComplement: PropTypes.bool,
      rugInscribed: PropTypes.bool,
    }),
  }).isRequired,
};

export default ComplianceStatusCell;
